import React, { Component } from 'react';
import ScrollMenu from 'react-horizontal-scrolling-menu';
import Ebook from './Ebook'
import '../App.css';

 
// All item  component
// Important! add unique key
export const Menu = (list, libraryProps) => list.map(el => {
  const { title, id, publisher, category} = el;
 
  return (
    <Ebook
        key={id}
        id={id}
        title={title} 
        category={category}
        publisher={publisher}
        date='**/**/201*'
        libraryProps={libraryProps}
        />
  );
});
 
 
const Arrow = ({ text, className }) => {
  return (
    <div
      className={className}
    >{text}</div>
  );
};

var epubClicked = false;
const handleEpub = epubId =>
{
    console.log(epubId)
}
 
 
const ArrowLeft = Arrow({ text: '<', className: 'arrow-prev' });
const ArrowRight = Arrow({ text: '>', className: 'arrow-next' });
 
class HorizontalList extends Component {
  state = {
    selected: 0,
    epubList: [],
  };
  
  onSelect = key => {
    this.setState({ selected: key });
  }
 
  componentDidMount()
  {
    this.searchEpubByCategory()
    // console.log("TEST")
    // console.log(this.props)
    // console.log("TEST")
  }

  searchEpubByCategory()
  {
    var tempEpubList = []
    for(var i=0; i<this.props.ebooksData.length; i++)
    {
      if(this.props.ebooksData[i].category === this.props.category)
      {
        tempEpubList.push(this.props.ebooksData[i])
      }
    }
    this.setState({ epubList: tempEpubList })
  }

  render() {
    const { selected } = this.state;
    // Create menu from items
    const menu = Menu(this.state.epubList, this.props.libraryProps ,  selected);
    return (
      <div className="">
        <ScrollMenu
          data={menu}
          arrowLeft={ArrowLeft}
          arrowRight={ArrowRight}
          selected={selected}
          onSelect={this.onSelect}
        />
      </div>
    );
  }
}

export default HorizontalList